import axios from "axios";

class GetPostCodeDetails {
  async addressListFromPostCode(url, token) {
    var response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  }
}

export default new GetPostCodeDetails();
